import { render, staticRenderFns } from "./6-bg.vue?vue&type=template&id=09ff3551&"
import script from "./6-bg.vue?vue&type=script&lang=js&"
export * from "./6-bg.vue?vue&type=script&lang=js&"
import style0 from "./6-bg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports